import { IPlace } from "../models/IPlace";

export const TELE_PLACE: IPlace = {
    id: 'TELEREHABILITACJA',
    administrativeArea: '',
    name: 'Telerehabilitacja',
    useOnlyViewportForSearch: false,
    location: { lat: 51.919438, lng: 19.145136 },
    viewport: {
        northeast: { lat: 54.9054761, lng: 24.1458931 },
        southwest: { lat: 49.002025, lng: 14.1228641 }
    }
};


// WEBPACK FOOTER //
// ./src/constants/TelePlace.tsx